import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "other" }
const _hoisted_2 = { class: "optionsBox" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "重置", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "重置全部配置到初始状态", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "operation" }, null, -1)
const _hoisted_6 = { class: "btns" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 重置 ")

import reset from "@/utils/reset";

export default /*#__PURE__*/_defineComponent({
  __name: 'other',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(reset)(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})